import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, User, ShoppingCart, Briefcase, Bell } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { useNotifications } from '../contexts/NotificationContext';

export const BottomNavigation = () => {
  const location = useLocation();
  const { t } = useLanguage();
  const { unreadCount } = useNotifications();

  const navItems = [
    { to: '/', activePaths: ['/', '/app'], icon: <Home className="w-5 h-5" />, label: t('home') },
    { to: '/shop', activePaths: ['/shop', '/marketplace'], icon: <ShoppingCart className="w-5 h-5" />, label: t('shop') },
    { to: '/services', activePaths: ['/services', '/providers'], icon: <Briefcase className="w-5 h-5" />, label: t('service') },
    { 
      to: '/notifications',
      activePaths: ['/notifications'],
      icon: (
        <div className="relative">
          <Bell className="w-5 h-5" />
          {unreadCount > 0 && (
            <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full flex items-center justify-center">
              <span className="text-[10px] text-white font-bold">
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            </div>
          )}
        </div>
      ), 
      label: t('notifications') 
    },
    { to: '/me', activePaths: ['/me', '/profile'], icon: <User className="w-5 h-5" />, label: t('profile') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 w-full bg-gray-100/95 backdrop-blur-lg border-t border-gray-700/70 z-50 rounded-t-2xl shadow-xl">
      <ul className="flex justify-around py-3">
        {navItems.map((item) => {
          const isActive = item.activePaths.includes(location.pathname);
          return (
            <li key={item.to} className="relative flex flex-col items-center justify-center">
              <Link
                to={item.to}
                className="flex flex-col items-center"
              >
                <div className={`flex items-center justify-center w-10 h-10 rounded-full transition-all duration-300 mb-1 ${
                  isActive 
                    ? 'bg-gradient-to-r from-primary-600 to-primary-500 text-white shadow-lg scale-110 -translate-y-1' 
                    : 'text-gray-400 hover:text-gray-200 hover:bg-gray-700/40'
                }`}>
                  {item.icon}
                </div>
                <span className={`text-xs font-medium ${
                  isActive ? 'text-primary-400' : 'text-gray-400'
                }`}>
                  {item.label}
                </span>
              </Link>
              {isActive && (
                <div className="absolute -bottom-2 left-1/2 w-5 h-1.5 bg-primary-500/30 rounded-full -translate-x-1/2 blur-md" />
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};